import {advancedRawRuleDefaults} from './defaults';
import {AdvancedRawRule} from './types';

type GetFileFormatFamilyRuleParams = {
	raw: string;
};

export const createAdvancedRawRule = ({
	raw,
}: GetFileFormatFamilyRuleParams): AdvancedRawRule => ({
	...advancedRawRuleDefaults,
	elementValue1: raw,
});

export default createAdvancedRawRule;
